import React, { createContext, useState } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

const AuthContextProvider = (props) => {

    let [userState, setUserState] = useState({
        token: '', 
        user: {},
        isAuthenticated: false,
        userType: '',
        loggedInUser: {}
    });

    if(localStorage.getItem('userState'))
    {
        let state  = JSON.parse(localStorage.getItem('userState'))
        userState = {
            token: state.token,  
            user: state.user,
            isAuthenticated: state.isAuthenticated,
            userType: state.userType,
            loggedInUser: state.loggedInUser
        }
    }

    const updateUserState = (token, authUser, authenticated, userType, loggedInUser) => {
        setUserState({token: token, user: authUser, isAuthenticated: authenticated, userType: userType, loggedInUser: loggedInUser});
        
        localStorage.setItem('userState', JSON.stringify({token: token, user: authUser, isAuthenticated: authenticated, userType: userType, loggedInUser: loggedInUser}));
    };

    const resetUserState = () => {
        setUserState({
            token: '', 
            user: {},
            isAuthenticated: false,
            userType: '',
            loggedInUser: {}
        });
   
        localStorage.clear();
    }

    return (  
        <AuthContext.Provider value={{userState, updateUserState, resetUserState}}>
            {props.children}
        </AuthContext.Provider>
    );
}
 
export default AuthContextProvider;